import React from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import CSS from "csstype";
import { RoundTableLogo } from "../Svgs";

interface ILoadingSpinnerProps {
	color?: string;
}

const LoadingSpinner: React.FC<ILoadingSpinnerProps> = ({ color }) => {
	const container: CSS.Properties = {
		display: "flex",
		position: "relative",
		height: `${window.innerHeight}px`,
		justifyContent: "center",
		alignItems: "center",
	};
	const useStyles = makeStyles({
		root: { color, position: "absolute" },
	});
	const { root } = useStyles();

	return (
		<div style={container}>
			<RoundTableLogo />
			<CircularProgress classes={{ root }} size={100} thickness={2} />
		</div>
	);
};

export default LoadingSpinner;
